module.exports = __webpack_public_path__ + "img/Home.87036d22.jpg";